import * as React from "react";
import type { SVGProps } from "react";
const SvgRollout = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 23" {...props}>
        <path
            fill="currentColor"
            d="M6.605 3.113a.484.484 0 0 0-.488.48v12.458c0 .265-.222.48-.492.48a.484.484 0 0 1-.488-.48V3.594c0-.793.656-1.438 1.468-1.438H17.38c.812 0 1.473.645 1.473 1.438v15.332c0 .797-.66 1.437-1.473 1.437H6.605c-.812 0-1.468-.64-1.468-1.437v-.957c0-.266.218-.48.488-.48s.492.214.492.48v.957c0 .265.219.48.488.48H17.38a.485.485 0 0 0 .492-.48V3.594a.485.485 0 0 0-.492-.48Zm9.305 2.875H8.074a.484.484 0 0 1-.488-.476c0-.266.219-.48.488-.48h7.836c.274 0 .492.214.492.48a.484.484 0 0 1-.492.476m-8.324 8.625h3.918v.961H7.586Zm4.898 0h3.918v.961h-3.918Zm-4.898 1.918h3.918v.957H7.586Zm4.898 0h3.918v.957h-3.918Zm0 0"
            style={{
                stroke: "none",
                fillRule: "evenodd",
                fillOpacity: 1,
            }}
        />
    </svg>
);
export default SvgRollout;
